module.exports = __webpack_public_path__ + "static/media/example-2.a20eeabf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/Churchview/example-2.jpg
// module id = 227
// module chunks = 0